import { globalTheme } from "srs.sharedcomponents/lib/esm/styles/config";

const robinairThemeColor = "#e83a42";
export const customTheme = {
  ...globalTheme,
  colors: {
    ...globalTheme.colors,
    primary: robinairThemeColor,
  },
};
